$(document).ready(function () {
  /*********************************/
  /*         タブスライダー        */
  /*********************************/


    /* 
  $('.js-lp-item-nav').slick({
    infinite: false,            
    variableWidth: true,       
    centerMode: false,
    centerPadding: '0',
    lazyLoad: 'progressive',
    arrows: false,             
    swipeToSlide: true,       
    touchMove: true,         
  });
  **/

  /*********************************/
  /*          タブ切り替え         */
  /*********************************/
  // 初期設定
  var initialTab = $(".js-tab.is-current"); // 事前に"is-current"が付与されているタブを取得
  if (initialTab.length === 0) {
    // "is-current"が付与されていない場合、最初のタブをデフォルトに設定
    initialTab = $(".js-tab").first();
    initialTab.addClass("is-current");

    // ★追加：同じ階層の親などに .is-current を付ける（例: liタグが親の場合）
    initialTab.closest('.js-tab').addClass("is-current"); // 変更不要ならこの行だけでもOK
    initialTab.parent().addClass("is-current"); // 例：li > .js-tab構造の場合
  }

  var target = initialTab.data("target"); // 対応するコンテンツを取得
  $(".js-content").hide(); // 全コンテンツを非表示
  $("#" + target).addClass("is-current").show(); // 対応するコンテンツを表示し、is-currentを追加

  // タブ切り替えイベント
  $(".js-tab").on("click", function () {
    // タブとその親要素の is-current を一旦削除
    $(".js-tab").removeClass("is-current");
    $(".js-tab").parent().removeClass("is-current");

    $(this).addClass("is-current");
    $(this).parent().addClass("is-current");

    // コンテンツ切り替え
    $(".js-content").removeClass("is-current").hide();
    var target = $(this).data("target");
    $("#" + target).addClass("is-current").fadeIn(300);
  });
    // 「次へ」ボタン
  $(".tab-buttons__next").on("click", function () {
    var $current = $(".js-tab.is-current");
    var $next = $current.closest('.js-tab').nextAll(".js-tab").first();

    if ($next.length > 0) {
      $next.trigger("click");
    }
  });

  // 「前へ」ボタン
  $(".tab-buttons__prev").on("click", function () {
    var $current = $(".js-tab.is-current");
    var $prev = $current.closest('.js-tab').prevAll(".js-tab").first();

    if ($prev.length > 0) {
      $prev.trigger("click");
    }
  });




  /************************************/
  /*   コンテンツ読み込みと絞り込み   */
  /************************************/
  if (!$('.manufacturer_selector').length) return;

  var currentTag = '{{current_tags}}';
  var modelGroups = window.fox.settings.model_groups_checkbox;

  // 共通の<select>を生成
  if (!$('.model-select').length) {
    $('.manufacturer_selector').append('<select class="model-select"></select>');

    // 最初の<option>を追加
    $('.model-select').append('<option value="" disabled selected>機種選択</option>');
  }

  // 機種を選択肢に追加する関数
  function addModelOption(modelCode, label) {
    var $option = `<option value="mo_${modelCode}">${label}</option>`;
    $('.model-select').append($option);

    // 初期選択状態を確認
    if (currentTag.match(`mo_${modelCode}`)) {
      $('.model-select').addClass('add_check');
    }
  }

  // 機種データを処理して選択肢を追加
  modelGroups.forEach(group => {
    group.code_sort.forEach(modelCode => {
      if (modelCode.match(/AP/)) {
        addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (iPhone)`);
      } else {
        addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (Android)`);
      }
    });
  });

  // **タブクリック時に対応する.is-currentのjs-contentの中身を取得して更新**
  async function loadContentForTab(targetContent) {
    const $currentContent = $(targetContent);  // .js-contentに対応する要素を取得
    if ($currentContent.length === 0) return;  // 対応するコンテンツが見つからない場合は終了

    const collectionUrl = $currentContent.data('collection-url');  // data-collection-urlからURLを取得
    const $list = $currentContent.find('.lp-item__list');  // 対象のリスト要素

    console.log('Fetching URL for current tab:', collectionUrl);

    try {
      // URLが空でないか確認
      if (collectionUrl) {
        const response = await fetch(collectionUrl);  // URLからデータをフェッチ
        if (!response.ok) {
          console.error('Failed to fetch the HTML:', response.statusText);
          return;
        }

        const htmlText = await response.text();  // 取得したHTMLをテキストとして読み込む
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const newGridContent = doc.querySelector('.collection.grid');  // 必要な部分を選択

        if (!newGridContent) {
          console.warn('.collection.grid not found in the fetched HTML.');
          return;
        }

        const products = Array.from(newGridContent.querySelectorAll('.product-item'));
        const emptyContent = newGridContent.querySelector('.collection-empty');

        let newHtml = '';

        // .product-itemが0個の場合でも.collection-emptyを含めて出力
        if (products.length > 0) {
          newHtml = products.slice(0, 200).map(product => product.outerHTML).join('');
        } else if (emptyContent) {
          newHtml = emptyContent.outerHTML;  // .collection-emptyがあればそのまま出力
        } else {
          newHtml = newGridContent.innerHTML;  // .product-itemも.collection-emptyもない場合、そのまま出力
        }

        $list.html(newHtml);  // リストの中身を更新
        console.log('Content replaced successfully for current tab.');

        
        // タイトル整形処理をここで追加
        $list.find('.product-slideShow-title').each(function () {
          const original = $(this).text();
          const matched = original.match(/.*?-([\s\S]*)/);
          if (matched && matched[1]) {
            $(this).text(matched[1].trim());
          }
        });

        // タイトル表示の制御
        const showTitle = $currentContent.data('show-title');
        if (showTitle) {
          $list.find('.product-slideShow-title').css({
            display: 'block',
            color: '#333',
            textAlign: 'center'
          });
        }

        // 価格表示の制御
        const showPrice = $currentContent.data('show-price');
        if (showPrice) {
          $list.find('.product-slideShow-price').css({
            display: 'block'
          });
        }






        $list.find('.product-item').each(function () {
          const $item = $(this);
          const tagsAttr = $item.attr('data-product-tags');
        
          if (tagsAttr) {
            try {
              const decoded = tagsAttr.replace(/&quot;/g, '"');
              const tags = JSON.parse(decoded);
        
              const freewordTags = tags.filter(tag => tag.startsWith('freeword_'));
        
              if (freewordTags.length > 0) {
                const $wrapper = $('<div class="product-slideShow-freeword-list"></div>');
        
                freewordTags.forEach(tag => {
                  const label = tag.replace('freeword_', '');
                  const $span = $('<span class="product-slideShow-freeword-tag"></span>').text(label);
                  $wrapper.append($span);
                });
        
                $item.append($wrapper);
              }
            } catch (e) {
              console.error('freewordタグの抽出に失敗:', e);
            }
          }
        });
        
        
        







      }
    } catch (error) {
      console.error('Error fetching and parsing HTML:', error);
    }
  }

  // 初期状態で表示されているタブのコンテンツを取得
  const initialTargetContent = $('.js-tab.is-current').data('target');
  loadContentForTab(`#${initialTargetContent}`);

  // **タブクリック時の処理**
  $(".js-tab").on("click", function () {
    // クリックされたタブに対応するコンテンツにis-currentクラスを追加
    const targetContentId = $(this).data("target"); // クリックされたタブのdata-target属性の値
    const targetContent = $(`#${targetContentId}`); // 対象のコンテンツを取得

    // 対象のコンテンツのデータURLを取得してHTMLを更新
    loadContentForTab(targetContent);
  });

  // OSと機種のコレクション
  var checkboxCollection = 'series-iphone ,series-android ,xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';

  // 選択時の処理
  $('.model-select').change(async function () {
    const currentHandle = $('.js-tab.is-current').data('handle');
    const selectedValue = $(this).val();

    // currentHandleがcheckboxCollectionに含まれているかをチェック
    let url;
    if (checkboxCollection.includes(currentHandle)) {
      url = `/collections/all-case/${selectedValue}`;
    } else {
      url = `/collections/${currentHandle}/${selectedValue}`;
    }

    console.log('Fetching URL:', url);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error('Failed to fetch the HTML:', response.statusText);
        return;
      }

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newGridContent = doc.querySelector('.collection.grid');

      if (!newGridContent) {
        console.warn('.collection.grid not found in the fetched HTML.');
        return;
      }

      const currentList = $('.js-content.is-current .lp-item__list');
      if (currentList.length) {
        // 最大40個の.product-itemを取得
        const products = Array.from(newGridContent.querySelectorAll('.product-item')).slice(0, 40);
        const emptyContent = newGridContent.querySelector('.collection-empty');

        let newHtml = '';

        // .product-itemが0個の場合でも.collection-emptyを含めて出力
        if (products.length > 0) {
          newHtml = products.map(product => product.outerHTML).join('');
        } else if (emptyContent) {
          newHtml = emptyContent.outerHTML;  // .collection-emptyがあればそのまま出力
        } else {
          newHtml = newGridContent.innerHTML;  // .product-itemも.collection-emptyもない場合、そのまま出力
        }

        currentList.html(newHtml);
        console.log('Content replaced successfully.');
      } else {
        console.warn('.lp-item__list not found in the current tab.');
      }
    } catch (error) {
      console.error('Error fetching and parsing HTML:', error);
    }
  });
});

// fox_3v.jsを改造した旧コード
// (function() {
//   $(document).ready(function() {
//     var $option, l, len2, len3, m, model_code, model_group, ref2, ref3, selected_option;
//     /* コレクションページサイドバーの機種選択初期処理 */
//     if ($('.manufacturer_selector').length) {
//       //現在の機種取得
//       selected_option = $('.collection-sidebar .model_selector .active').val();
//       ref2 = window.fox.settings.model_groups_checkbox;

//       /* --- 複数使用するものは関数に --- */
//       //小カテゴリ「iphone」「android」リンクの配列
//       var iPhone_model_code = [];
//       var android_model_code = [];

//       //OSと機種のコレクション
//       var checkbox_collection = 'series-iphone ,series-android , xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';

//       //iphone機種名リンク
//       var iphonemodel_link = function() {
//         if (model_code.match(/AP/)) {
//           // iPhoneの機種名を<option>タグとして作成
//           $option = '<option value="mo_' + model_code + '">' + window.fox.settings.model[model_code] + ' (iPhone)</option>';

//           // すでに<select>タグがある場合、その中に<option>を追加する
//           if ($('.model-select').length === 0) {
//             // <select>タグがまだ無ければ、1つ目の<select>を追加
//             $('.manufacturer_selector').append('<select class="model-select"></select>');
//           }

//           // 追加した<select>に<option>を追加
//           $('.model-select').append($option);

//           iPhone_model_code.push(model_code);

//           // 変更時にリンクに飛ばす
//           (function(m) {
//             $('.model-select').change(function() {
//                 // 現在選択されているタブ(.is-current)からdata-handle属性を取得
//                 var currentHandle = $('.js-tab.is-current').data('handle');
//                 var selectedValue = $(this).val();
//                 // handleがcheckbox_collectionに含まれているかをチェック
//                 if (checkbox_collection.includes(currentHandle)) {
//                   location.href = '/collections/all-case/' + selectedValue;
//                 } else {
//                   location.href = '/collections/' + currentHandle + '/' + selectedValue;
//                 }
//             });
//             // 初期状態で選択されている場合はクラスを付ける
//             if (current_tag.match('mo_' + model_code)) {
//               $('.model-select').addClass("add_check");
//             }
//           })(m);
//         }
//       };

//       //android機種名リンク
//       var androidmodel_link = function() {
//         if (!model_code.match(/AP/)) {
//           // Androidの機種名を<option>タグとして作成
//           $option = '<option value="mo_' + model_code + '">' + window.fox.settings.model[model_code] + ' (Android)</option>';

//           // 追加した<select>に<option>を追加
//           $('.model-select').append($option);

//           android_model_code.push(model_code);

//           // 変更時にリンクに飛ばす
//           (function(m) {
//             $('.model-select').change(function() {
//               var currentHandle = $('.js-tab.is-current').data('handle');
//               var selectedValue = $(this).val();
//               // handleがcheckbox_collectionに含まれているかをチェック
//               if (checkbox_collection.includes(currentHandle)) {
//                 location.href = '/collections/all-case/' + selectedValue;
//               } else {
//                 location.href = '/collections/' + currentHandle + '/' + selectedValue;
//               }
//             });
//             // 初期状態で選択されている場合はクラスを付ける
//             if (current_tag.match('mo_' + model_code)) {
//               $('.model-select').addClass("add_check");
//             }
//           })(m);
//         }
//       };

//       /* --- 大カテゴリ作成 --- */
//       for (l = 0, len2 = ref2.length; l < len2; l++) {
//         model_group = ref2[l];
//         /* --- 小カテゴリ作成 --- */
//         ref3 = model_group.code_sort;
//         for (m = 0, len3 = ref3.length; m < len3; m++) {
//           model_code = ref3[m];
//             iphonemodel_link();
//             androidmodel_link();
//         }
//       }

//       if ($('.model-select').hasClass('add_check')) {
//         $('.model-select').show();
//       }
//     }

//   });
// }).call(this);

// 一旦完璧
// (function () {
//   $(document).ready(function () {
//     if (!$('.manufacturer_selector').length) return;

//     var currentTag = '{{current_tags}}';
//     var modelGroups = window.fox.settings.model_groups_checkbox;

//     // 共通の<select>を生成
//     if (!$('.model-select').length) {
//       $('.manufacturer_selector').append('<select class="model-select"></select>');

//       // 最初の<option>を追加
//       $('.model-select').append('<option value="" disabled selected>絞り込み</option>');
//     }

//     // 機種を選択肢に追加する関数
//     function addModelOption(modelCode, label) {
//       var $option = `<option value="mo_${modelCode}">${label}</option>`;
//       $('.model-select').append($option);

//       // 初期選択状態を確認
//       if (currentTag.match(`mo_${modelCode}`)) {
//         $('.model-select').addClass('add_check');
//       }
//     }

//     // 機種データを処理して選択肢を追加
//     modelGroups.forEach(group => {
//       group.code_sort.forEach(modelCode => {
//         if (modelCode.match(/AP/)) {
//           addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (iPhone)`);
//         } else {
//           addModelOption(modelCode, `${window.fox.settings.model[modelCode]} (Android)`);
//         }
//       });
//     });

//     // OSと機種のコレクション
//     var checkboxCollection = 'series-iphone ,series-android ,xperia-series, galaxy-series, pixel-series, xiaomi-series, motorola-series';

//     // 選択時の処理
//     $('.model-select').change(async function () {
//       const currentHandle = $('.js-tab.is-current').data('handle');
//       const selectedValue = $(this).val();

//       // currentHandleがcheckboxCollectionに含まれているかをチェック
//       let url;
//       if (heckboxCollection.includes(currentHandle)) {
//         url = `/collections/all-case/${selectedValue}`;
//       } else {
//         url = `c/collections/${currentHandle}/${selectedValue}`;
//       }

//       console.log('Fetching URL:', url);

//       try {
//         const response = await fetch(url);
//         if (!response.ok) {
//           console.error('Failed to fetch the HTML:', response.statusText);
//           return;
//         }

//         const htmlText = await response.text();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(htmlText, 'text/html');
//         const newGridContent = doc.querySelector('.collection.grid');

//         if (!newGridContent) {
//           console.warn('.collection.grid not found in the fetched HTML.');
//           return;
//         }

//         const currentList = $('.js-content.is-current .lp-item__list');
//         if (currentList.length) {
//           // 最大40個の.product-itemを取得
//           const products = Array.from(newGridContent.querySelectorAll('.product-item')).slice(0, 40);
//           const newHtml = products.map(product => product.outerHTML).join('');
//           currentList.html(newHtml);
//           console.log('Content replaced successfully.');
//         } else {
//           console.warn('.lp-item__list not found in the current tab.');
//         }
//       } catch (error) {
//         console.error('Error fetching and parsing HTML:', error);
//       }
//     });

//     // **ロード時にすべてのタブを処理してコンテンツを差し替える**
//     async function replaceAllLists() {
//       $('.lp-item__content').each(async function () {
//         const $content = $(this);
//         const collectionUrl = $content.data('collection-url'); // data-collection-url属性からURLを取得
//         const $list = $content.find('.lp-item__list');

//         console.log('Fetching URL (initial load):', collectionUrl);

//         try {
//           const response = await fetch(collectionUrl);
//           if (!response.ok) {
//             console.error('Failed to fetch the HTML:', response.statusText);
//             return;
//           }

//           const htmlText = await response.text();
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(htmlText, 'text/html');
//           const newGridContent = doc.querySelector('.collection.grid');

//           if (!newGridContent) {
//             console.warn('.collection.grid not found in the fetched HTML.');
//             return;
//           }

//           // 最大40個の.product-itemを取得
//           const products = Array.from(newGridContent.querySelectorAll('.product-item')).slice(0, 40);
//           const newHtml = products.map(product => product.outerHTML).join('');
//           $list.html(newHtml);
//           console.log('Initial content replaced for:', collectionUrl);
//         } catch (error) {
//           console.error('Error fetching and parsing HTML:', error);
//         }
//       });
//     }

//     // 初期状態で全タブのリストを置き換え
//     replaceAllLists();

//     // 初期状態で表示設定
//     if ($('.model-select').hasClass('add_check')) {
//       $('.model-select').show();
//     }
//   });
// })();
